import Axios from 'axios';

export const fetchShipmentDetail = async (url: string) => {
	try {
		const result = await Axios({
			method: 'get',
			url: url,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'content-type': 'application/json; charset=utf-8',
			},
		});
		return result.data || null;
	} catch (err) {
		console.error(err);
		return null;
	}
};
